module.exports = __webpack_public_path__ + "static/media/capex.2e463014.svg";